import { useContext, useEffect } from 'react';
import { AppContext } from "../../context/app-context";
import { Button} from 'antd';
import usePowerBiToken from '../../components/shared/hooks/usePowerBiToken';
import { useState } from 'react';
import { Report } from 'powerbi-report-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loading } from '../../components/shared/Loading';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

import './ReportPage.scss';

const ReportPage = () => {
  const { profile, isLoadingCountry: loading} = useContext(AppContext);

  const [authToken, setAuthToken] = useState<string>();
  const powerBiAuthToken = usePowerBiToken();

  const [isFullscreen, setFullscreen] = useState<boolean>(false);

  const [profileLoading, setProfileLoading] = useState<boolean>(true);

  const setToken = (token: string) => {
	setAuthToken(token);
  }

  var extraSettings = {
    filterPaneEnabled: false,
	navContentPaneEnabled: true,
  };

  useEffect(() => {
	if (!authToken && !profileLoading) powerBiAuthToken.useInitializeToken(setToken);
  }, [authToken, profileLoading, powerBiAuthToken]);

  const toggleFullscreen = () => {
    if (document.fullscreenElement !== null) {
	  document.exitFullscreen();
	  setFullscreen(false);
	} else {
	  document.getElementById("report")?.requestFullscreen();
	  setFullscreen(true);
	}
  };

  useEffect(() => {
	if(!loading && profile) setProfileLoading(false);
  }, [loading, profile])

  const overviewLoading = (!authToken || profileLoading);
  const overviewError = (!authToken && !profileLoading && !powerBiAuthToken.isLoading && powerBiAuthToken.isError);

  return (
	<div className={`content-body report-body`}>
		{ overviewError && (
			<div className="report-error">
			<FontAwesomeIcon icon={faExclamationTriangle} />
			<span>{"Error: There was an issue trying to reach this data"}</span>
			</div>
		)}
		{ !overviewError && overviewLoading && (
			<Loading />
		)}
		{ !overviewError && !overviewLoading && (
			<div id="report" className="report-container">
			<Report
				key="workspace"
				tokenType="Aad"
				accessToken={authToken!}
				embedUrl={`https://app.powerbi.com/reportEmbed?reportId=c7b72892-110c-44cd-9713-556ab8a5391c&groupId=307a95f0-504f-4c57-8358-1751e18bc334`}
				embedId="c7b72892-110c-44cd-9713-556ab8a5391c"
				reportMode="View"
				extraSettings={extraSettings}
				permissions="All"
			/>
			{!isFullscreen && <Button onClick={() => { toggleFullscreen(); }} type="text" className="expand" title="Maximize" icon={<FontAwesomeIcon icon={['far', 'expand']} />}></Button>}
			{isFullscreen && <Button onClick={() => { toggleFullscreen(); }} type="text" className="expand" title="Minimize" icon={<FontAwesomeIcon icon={['far', 'compress']} />}></Button>}
			</div>
		)}
	</div>
  );
}

export default ReportPage;

